import { render, staticRenderFns } from "./EmailReminder.vue?vue&type=template&id=1eddfeb3&scoped=true&lang=pug&"
import script from "./EmailReminder.vue?vue&type=script&lang=ts&"
export * from "./EmailReminder.vue?vue&type=script&lang=ts&"
import style0 from "./EmailReminder.vue?vue&type=style&index=0&id=1eddfeb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eddfeb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
